import { Container } from '@mui/material';
import { ComponentType } from 'react';
import { PageLayout } from 'src/layouts/page-layout';
import { About } from '../about';
import { Capabilities } from '../capabilities';
import { Statistics } from '../statistics';

export const Home: ComponentType = () => {
  // const classes = useStyles();
  // const { t } = useTranslation();

  return (
    <PageLayout isHomepage>
      <Container>
        {/* news */}
        {/* <NewsBlock title={t('portalNews', 'Новости портала')} showItems={3} mb={17.5} allNewsLink /> */}

        {/* about */}
        <About mb={17.5} />

        {/* capabilities */}
        <Capabilities mb={17.5} />

        {/* directions */}
        {/* <DirectionsBlock mb={17.5} /> */}

        {/* statistics */}
        <Statistics />
      </Container>

      {/* faq */}
      {/* <Box className={classes.lightBg}>
        <Container maxWidth="sm">
          <FAQ pt={17.5} pb={11} />
        </Container>
      </Box> */}
    </PageLayout>
  );
};
